import type { GameModeConfig } from './config';
import { citiesWorldPractice } from './configs/cities-world-practice';
import { citiesWorldDaily } from './configs/cities-world-daily';
import { countriesWorldPractice } from './configs/countries-world-practice';
import { ALL_COUNTRY_QUIZZES } from './configs/country-quizzes';

/**
 * Single source of truth for every game mode the app ships with. Sidebar,
 * router, and any "list all modes" surfaces consume this. When the admin
 * backend lands, this becomes an API call returning the same shape.
 *
 * Order matters — sidebar renders modes in this order. Daily comes
 * first so it's the most prominent option on every page load.
 */
export const ALL_MODES: GameModeConfig[] = [
  citiesWorldDaily,
  citiesWorldPractice,
  countriesWorldPractice,
  ...ALL_COUNTRY_QUIZZES,
];

/**
 * The mode the app shows when the user lands on `/`. Single source of
 * truth so the home route and the sidebar's active-state matching
 * stay in sync — change this constant and both follow.
 */
export const DEFAULT_MODE: GameModeConfig = citiesWorldDaily;

/** Look up a mode by canonical id. Returns undefined if not registered. */
export function getMode(id: string): GameModeConfig | undefined {
  return ALL_MODES.find((m) => m.id === id);
}

/**
 * Look up by URL path fragments. Reconstructs the id and queries the
 * registry. URL `/play/cities-world/practice` → scope=`cities-world`,
 * format=`practice` → id=`cities-world-practice`.
 */
export function getModeByUrlFragments(
  scopeSlug: string,
  formatSlug: string,
): GameModeConfig | undefined {
  return getMode(`${scopeSlug}-${formatSlug}`);
}
